// Helpers for loading data that other users have shared with the current user.
import { collection, query, where, getDocs, getDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';

// 10 default highlight colors the owner can assign to shared users.
// Keep in sync with SHARE_COLORS in functions/index.js.
export const SHARE_COLORS = [
  '#fde68a', '#fca5a5', '#a7f3d0', '#93c5fd', '#c4b5fd',
  '#f9a8d4', '#fdba74', '#6ee7b7', '#bef264', '#67e8f9',
];

// Fetch the share docs where the given user is the recipient.
export const fetchIncomingShares = async (uid) => {
  if (!uid) return [];
  const q = query(collection(db, 'shares'), where('recipientUid', '==', uid));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

// Given the incoming shares, load the actual shared vehicles and events from
// each owner's collections. Returned items are tagged so the UI can mark them
// as shared and so editors know which account to read/write.
export const fetchSharedItems = async (shares) => {
  const vehicles = [];
  const events = [];

  for (const share of shares) {
    const { ownerUid, ownerEmail } = share;
    const vehicleIds = share.vehicleIds || [];
    const eventIds = share.eventIds || [];

    const vehicleDocs = await Promise.all(
      vehicleIds.map(id => getDoc(doc(db, `users/${ownerUid}/vehicles/${id}`)))
    );
    vehicleDocs.forEach(d => {
      if (d.exists()) {
        vehicles.push({ id: d.id, ...d.data(), shared: true, ownerUid, ownerEmail });
      }
    });

    const eventDocs = await Promise.all(
      eventIds.map(id => getDoc(doc(db, `users/${ownerUid}/events/${id}`)))
    );
    eventDocs.forEach(d => {
      if (d.exists()) {
        events.push({ id: d.id, ...d.data(), shared: true, ownerUid, ownerEmail });
      }
    });
  }

  return { vehicles, events };
};
